import React from "react"

import Grid, { Col } from "components/grid"
import { Paragraph, H4 } from "components/text"
import { Box } from "components/box"

import { GetStartedButton } from "components/marketing/get-started-button"
import { ProgressiveImageSrcSet } from "shared/image-content/image-srcset"
import { LoadingWrapper } from "components/loading-wrapper"

import { getFormatDiscountPrice } from "shared/products/helpers"
import { useRootQuery } from "graphql/smart-queries/user"

type PromoProps = {
  imgSrc: string
  mobileImgSrc: string
}

export const Promo: React.FC<PromoProps> = ({ imgSrc, mobileImgSrc }) => {
  const { data, loading, error } = useRootQuery()

  const discount =
    data?.currentOffer?.discountPercentage &&
    getFormatDiscountPrice({ discountPercentage: data.currentOffer.discountPercentage, withPercent: true })

  return (
    <Grid px={[0, 0]}>
      <Col cols={[4, 4, 8, 8]}>
        <ProgressiveImageSrcSet src={imgSrc} small={mobileImgSrc} />
      </Col>
      <Col cols={[4, 4, 4, 4]}>
        <Box px={[5, 6, 0, 0]}>
          <H4 py={5} mb={1}>
            Ready for expert-backed migraine treatment?
          </H4>
          <LoadingWrapper loading={loading} error={error}>
            <Paragraph mb={3}>
              Complete your online consultation today to get {discount} off your first month of Cove.
            </Paragraph>
          </LoadingWrapper>
          <Box width={["100%", null, 260]}>
            <GetStartedButton />
          </Box>
        </Box>
      </Col>
    </Grid>
  )
}
